import { useMutation } from "@tanstack/react-query";
import type { SubscriptionInfo } from "lens-platform-sdk";
import { LensSDKException } from "lens-platform-sdk";
import { useLensPlatformClient } from "./useLensPlatformClient";

/**
 * Hook for updating business subscription custom field
 */
export const useUpdateBusinessSubscriptionCustomField = () => {
  const lensPlatformClient = useLensPlatformClient();

  const {
    isLoading: updatingBusinessSubscriptionCustomField,
    isSuccess: updateBusinessSubscriptionCustomFieldSuccess,
    error: errorUpdatingBusinessSubscriptionCustomField,
    mutate: updateBusinessSubscriptionCustomField,
    data: businessSubscriptionCustomField,
  } = useMutation<
    SubscriptionInfo,
    LensSDKException,
    {
      businessId: string;
      businessSubscriptionId: string;
      customField: { name: string; value: string };
    }
  >(({ businessId, businessSubscriptionId, customField }) =>
    lensPlatformClient.business.updateBusinessSubscriptionCustomField({
      businessSubscriptionId,
      businessId,
      customField,
    }),
  );

  return {
    businessSubscriptionCustomField,
    updateBusinessSubscriptionCustomField,
    updateBusinessSubscriptionCustomFieldSuccess,
    updatingBusinessSubscriptionCustomField,
    errorUpdatingBusinessSubscriptionCustomField,
  };
};
